import { combineSlices } from "@reduxjs/toolkit";

import detailSlice from "./detail/shreddingDetailSlice";
import shreddingFiltersSlice from "./filters/shreddingFiltersSlice";
import homeSlice from "./home/shreddingHomeSlice";

const combined = combineSlices(shreddingFiltersSlice, homeSlice, detailSlice);

export default combined;
